/**
 * Default keyboard shortcut mappings for Imagia Mail.
 * Each entry maps an action name to a key descriptor.
 *
 * Key format: plain key name (e.g., 'c', 'a', '/', 'Escape')
 * or modifier combos: 'Shift+I', 'Ctrl+Enter'
 *
 * Two-key sequences use 'g+i' format (press g, then i within 1s).
 */

export const DEFAULT_SHORTCUTS = {
  compose: 'c',
  reply: 'r',
  replyAll: 'a',
  forward: 'f',
  archive: 'e',
  trash: '#',
  star: 's',
  nextEmail: 'j',
  prevEmail: 'k',
  openEmail: 'o',
  backToList: 'u',
  focusSearch: '/',
  escape: 'Escape',
  showHelp: '?',
  markRead: 'Shift+I',
  markUnread: 'Shift+U',
  goInbox: 'g+i',
  goStarred: 'g+s',
  goSent: 'g+t',
  goDrafts: 'g+d',
  goArchive: 'g+a',
  sendEmail: 'Ctrl+Enter',
};

export const SHORTCUT_LABELS = {
  compose: 'Compose',
  reply: 'Reply',
  replyAll: 'Reply All',
  forward: 'Forward',
  archive: 'Archive',
  trash: 'Delete',
  star: 'Star/Unstar',
  nextEmail: 'Next email',
  prevEmail: 'Previous email',
  openEmail: 'Open email',
  backToList: 'Back to list',
  focusSearch: 'Focus search',
  escape: 'Close/Cancel',
  showHelp: 'Shortcuts help',
  markRead: 'Mark as read',
  markUnread: 'Mark as unread',
  goInbox: 'Go to Inbox',
  goStarred: 'Go to Starred',
  goSent: 'Go to Sent',
  goDrafts: 'Go to Drafts',
  goArchive: 'Go to Archive',
  sendEmail: 'Send email',
};

const STORAGE_KEY = 'imagia_mail_shortcuts';

export function loadShortcuts() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      return { ...DEFAULT_SHORTCUTS, ...JSON.parse(saved) };
    }
  } catch { /* ignore */ }
  return { ...DEFAULT_SHORTCUTS };
}

export function saveShortcuts(shortcuts) {
  // Only save non-default values to keep storage minimal
  const diff = {};
  for (const [key, val] of Object.entries(shortcuts)) {
    if (val !== DEFAULT_SHORTCUTS[key]) {
      diff[key] = val;
    }
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(diff));
}
